import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { bucket } from "../firebase";

export const uploadDocument = async (fl, path = `/portfolio/trash/`) => {
  const storageRef = ref(bucket, path);
  const uploadTask = uploadBytesResumable(storageRef, fl);

  return getDownloadURL(uploadTask.snapshot.ref);
};